import React, { useEffect, startTransition } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import HomePage from './pages/HomePage';
import './App.css';
import { useDispatch } from 'react-redux';
import { loadDestinations, loadAirports } from './store/searchSlice';
import { SearchResultsProvider } from './context/SearchResultsContext';

// Create router with all future flags enabled
const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <HomePage />
    },
    {
      path: "/results",
      element: <HomePage />
    },
    {
      path: "/alerts",
      element: <HomePage />
    }
  ],
  {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true,
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_skipActionErrorRevalidation: true
    }
  }
);

function AppWrapper() {
  const dispatch = useDispatch();

  useEffect(() => {
    startTransition(() => {
      dispatch(loadDestinations());
      dispatch(loadAirports());
    });
  }, [dispatch]);

  return (
    <SearchResultsProvider>
      <React.Suspense fallback={<div>Loading...</div>}>
        <RouterProvider router={router} />
      </React.Suspense>
    </SearchResultsProvider>
  );
}

export default AppWrapper;